import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Footer from './Footer';
import StatusBar from './StatusBar';
import { useSidebar } from '../contexts/SidebarContext';
import { useUploadStatus } from '../contexts/UploadStatusContext';
import { useAuth } from '../contexts/AuthContext';
import usePendingRunsAutoSync from '../hooks/usePendingRunsAutoSync';
import './AppLayout.css';

const AppLayout = ({ children }) => {
  const location = useLocation();
  const { isCollapsed } = useSidebar();
  const { saveRun, cloudSyncRun, youtubeUpload, goproExtraction, genericTasks, exportVideo } = useUploadStatus();
  const { user } = useAuth();
  usePendingRunsAutoSync(user);

  const sidebarPages = ['/home', '/my-rides', '/live', '/calendar', '/ride', '/compare', '/help', '/tuning-guide', '/profile', '/settings', '/dashboard', '/buy-credits', '/create-run', '/groups', '/admin'];
  const showSidebar = !!user && sidebarPages.some(path => location.pathname.startsWith(path));

  const publicPages = [
    '/',
    '/landing',
    '/login',
    '/signup',
    '/bike-onboarding',
    '/pre-order',
    '/about',
    '/philosophy',
    '/privacypolicy',
    '/tos',
    '/support',
  ];
  const isPublicGroupPage = location.pathname.startsWith('/g/');
  const isPublicHome = !user && location.pathname === '/home';
  const isPublicPage = publicPages.includes(location.pathname) || isPublicGroupPage || isPublicHome;
  const isRideCreatePage = location.pathname === '/ride/create' || location.pathname === '/ride/create/';
  const shouldShowFooter = !isPublicPage && !isRideCreatePage;

  const hasActiveUploads =
    saveRun.active ||
    cloudSyncRun.active ||
    youtubeUpload.active ||
    goproExtraction.active ||
    genericTasks.length > 0 ||
    exportVideo.active;

  /* Footer under the fold on every view: use flow layout whenever we show footer, or on landing */
  const isFooterFlowPage =
    shouldShowFooter ||
    location.pathname === '/' ||
    location.pathname === '/landing' ||
    location.pathname === '/pre-order' ||
    location.pathname === '/about' ||
    location.pathname === '/philosophy' ||
    location.pathname === '/privacypolicy' ||
    location.pathname === '/tos' ||
    location.pathname === '/support';

  return (
    <div className="app-layout">
      <StatusBar />
      <div className={`app-body ${hasActiveUploads ? 'has-status-bar' : ''}`}>
        {showSidebar && <Sidebar />}
        <div className={`app-body-right ${showSidebar ? 'with-sidebar' : ''} ${isCollapsed ? 'sidebar-collapsed' : ''} ${isFooterFlowPage ? 'legal-scroll' : ''}`}>
          <main className={`main-content ${showSidebar ? 'with-sidebar' : ''} ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
            {children}
          </main>
          {shouldShowFooter && <Footer />}
        </div>
      </div>
    </div>
  );
};

export default AppLayout;

